"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ProviderCardTabs = void 0;
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _intl = require("@kyruus/intl");
var _providerComponents = require("@kyruus/provider-components");
var _styles = require("../ProviderCard/styles");
var _messages = _interopRequireDefault(require("../../lib/constants/messages"));
const ProviderCardTabs = exports.ProviderCardTabs = (0, _intl.injectIntl)(_ref => {
  var _context, _context2;
  let {
    config,
    track,
    provider,
    customerCode,
    productName,
    LocationsProps,
    shouldDisplayAvailability,
    hasSlots,
    intl,
    ...restProps
  } = _ref;
  const showLocationsTab = ((_context = config.tabs) == null ? void 0 : (0, _bind.default)(_context2 = Function.call).call(_context2, (0, _some.default)(_context), _context))?.(tab => (typeof tab === 'string' ? tab : tab.id) === _providerComponents.BASE_TAB.LOCATIONS) && shouldDisplayAvailability && hasSlots;
  const handleActivateTab = (prevTab, tab, currentProvider) => {
    track?.(_providerComponents.LOGGING.MESSAGE.PROVIDER_TAB_CLICKED, {
      provider_id: currentProvider.id,
      prev_tab_name: prevTab,
      tab_name: tab
    });
  };
  const handleActivatePracticeGuidesTab = (prevTab, tab, currentPracticeGuide) => {
    track?.(_providerComponents.LOGGING.MESSAGE.PRACTICE_GUIDE_TAB_CLICKED, {
      provider_id: provider.id,
      practice_guide_name: currentPracticeGuide.name,
      prev_tab_name: prevTab,
      tab_name: tab
    });
  };
  const handleShowGuide = practice => {
    track?.(_providerComponents.LOGGING.MESSAGE.PRACTICE_GUIDE_VIEWED, {
      provider_id: provider.id,
      practice_group_id: practice.id,
      practice_group_name: practice.name
    });
  };
  const getTabTableEventHandlers = tab => ({
    // debounce the onSetGlobalFilter to avoid sending too
    // many events while the user types their search term
    onSetGlobalFilter: (0, _debounce.default)(action => {
      track?.(_providerComponents.LOGGING.MESSAGE.PROVIDER_TAB_TABLE_SEARCH, {
        provider_id: provider.id,
        tab_name: tab,
        search_term: action?.filterValue
      });
    }, 300)
  });
  const onRichTextLinkClick = (_e, tab, _ref2) => {
    let {
      content,
      href
    } = _ref2;
    track?.(_providerComponents.LOGGING.MESSAGE.PROVIDER_TABS_RICH_TEXT_LINK_CLICKED, {
      provider_id: provider.id,
      tab_name: tab,
      linkContent: content,
      linkHref: href
    });
  };
  return /*#__PURE__*/_react.default.createElement(_styles.ProviderTabsContainer, restProps, /*#__PURE__*/_react.default.createElement(_providerComponents.ProviderTabs, {
    key: showLocationsTab ? _providerComponents.BASE_TAB.LOCATIONS : undefined,
    provider: provider,
    initialActiveTab: showLocationsTab ? _providerComponents.BASE_TAB.LOCATIONS : config.initialActiveTab,
    customerCode: customerCode,
    tabs: config.tabs ?? [],
    LocationsProps: LocationsProps,
    PracticeGroupsProps: {
      onShowGuide: handleShowGuide,
      onActivateGuideTab: handleActivatePracticeGuidesTab
    },
    productName: productName,
    onActivate: handleActivateTab,
    getTableEventHandlers: getTabTableEventHandlers,
    onRichTextLinkClick: onRichTextLinkClick,
    labels: {
      practiceGroupsLabels: {
        noContentLabel: intl.formatMessage(_messages.default.practiceGroupAlertNoContent),
        alertsSection1Label: intl.formatMessage(_messages.default.practiceGroupAlertPracticeHeader),
        alertsSection2Label: intl.formatMessage(_messages.default.practiceGroupAlertTermHeader)
      }
    }
  }));
});